/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Redirect } from "react-router-dom";

import { withTranslation } from "react-i18next";

const SpyChat = ({ isOpen, conversationId, isByManager }) => {
  return (
    <>
      {/* <div className={isOpen ? "modal-span" : "d-none"}>
        <button onClick={toggle}>CLOSE</button> */}
      {isOpen && (
        <Redirect
          to={{
            pathname: "/chats",
            state: {
              spyConversationId: conversationId,
              isByManager: isByManager,
            },
          }}
        />
      )}
      {/* <span>MODAL {conversationId}</span>
      </div> */}
    </>
  );
};
export default withTranslation()(SpyChat);
